import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { TickCircle, Danger, CloseCircle } from 'iconsax-react';

export enum StockStatusEnum {
  IN_STOCK = 'IN_STOCK',
  LOW_STOCK = 'LOW_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  ACTIVE = 'ACTIVE', // Fallback for the green pill
}

type Props = {
  code?: string | null;
  name?: string | null;
  className?: string;
};

export default function StockStatusBadge({ code, name, className }: Props) {
  const { t } = useTranslation();

  if (!code) return null;

  return (
    <div className={cn(
      "flex items-center gap-2 px-3 py-1.5 rounded-[8px] text-sm font-medium min-w-fit",
      {
        "bg-green-50 dark:bg-green-900/20 text-light-success": code === StockStatusEnum.IN_STOCK,
        "bg-yellow-50 dark:bg-yellow-900/20 text-light-alert": code === StockStatusEnum.LOW_STOCK,
        "bg-red-50 dark:bg-red-900/20 text-light-warning": code === StockStatusEnum.OUT_OF_STOCK,
        "bg-gray-50 dark:bg-gray-800 text-gray-500": !Object.values(StockStatusEnum).includes(code as StockStatusEnum)
      },
      className
    )}>
      {code === StockStatusEnum.IN_STOCK && <TickCircle size={18} variant="Bold" />}
      {code === StockStatusEnum.LOW_STOCK && <Danger size={18} variant="Bold" />}
      {code === StockStatusEnum.OUT_OF_STOCK && <CloseCircle size={18} variant="Bold" />}

      {code === StockStatusEnum.IN_STOCK ? t('inStock') :
        code === StockStatusEnum.LOW_STOCK ? t('lowStock') :
          code === StockStatusEnum.OUT_OF_STOCK ? t('outOfStock') :
            name}
    </div>
  );
}
